import { createFileRoute, useNavigate } from '@tanstack/react-router';

import Button from '@mui/material/Button';

import { paths } from 'src/routes/paths';
import { Iconify } from 'src/components/iconify';
import OfferingsManager from 'src/components/settings/OfferingsManager';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/products/'
)({
  component: ClientProductsDetail,
});

function ClientProductsDetail() {
  const navigate = useNavigate();
  const { orgId, clientId } = Route.useParams();

  return (
    <>
      <Button
        size="small"
        startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
        onClick={() => navigate({ to: paths.dashboard.orgSettings(orgId).client.brandDetail(clientId) })}
        sx={{ mb: 2, textTransform: 'none' }}
      >
        Back to client
      </Button>
      <OfferingsManager orgId={orgId} clientId={clientId} />
    </>
  );
}
